import { render, staticRenderFns } from "./DocumentManagerDialog.vue?vue&type=template&id=5bd86271&scoped=true"
import script from "./DocumentManagerDialog.vue?vue&type=script&lang=js"
export * from "./DocumentManagerDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentManagerDialog.vue?vue&type=style&index=0&id=5bd86271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd86271",
  null
  
)

export default component.exports